import type { AsyncThunkApiConfig } from '@/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { unproxify } from '@/utils'

import { RejectError } from '../../typings'

type Payload = {
  orderStepIds: string[]
  cloneAlsoPairedStep?: boolean
  cloneEntireRecurrence: boolean
}

/**
 * Clone order steps.
 *
 * @private
 */
export const cloneOrderSteps = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.CloneOrderStepsActionResult,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/clone', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const response = await rpc('rpc/order/clone', {
      category: 'rpc',
      type: 'rpc/order/clone',
      payload: unproxify(payload),
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {cloneOrders}`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Cloning [${payload.orderStepIds}] Failed`,
      error,
    })
  }
})
